import * as ActionTypes from 'src/constants/ActionTypes';
import { IStateSelectDoctor } from 'src/entity/StateEntity';

const initialState: IStateSelectDoctor = {
  type: ActionTypes.DOCTOR_INVALIDATE,
};

export const selectDoctorState = (state: IStateSelectDoctor = initialState, action: IStateSelectDoctor): IStateSelectDoctor => {
  switch (action.type) {
    case ActionTypes.DOCTOR_SELECT:
      return Object.assign({}, state, {
        type: action.type,
        detailType: action.detailType,
        doctorInfo: action.doctorInfo,
      });
    case ActionTypes.DOCTOR_INVALIDATE:
      return Object.assign({}, state, {
        type: action.type,
        detailType: undefined,
        doctorInfo: undefined,
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/selectDoctorState.ts